import script from "./ChangePassword.vue?vue&type=script&setup=true&lang=js"
export * from "./ChangePassword.vue?vue&type=script&setup=true&lang=js"

import "./ChangePassword.vue?vue&type=style&index=0&id=2331cda2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2331cda2"]])

export default __exports__